import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

import { scrubTransportItem } from '@/lib/telemetry/scrub';
import { buildApiPropagationMatchers } from '@/lib/telemetry/trace-propagation';

// Literal process.env access is required for Next's static inlining of NEXT_PUBLIC_*.
const collectorUrl = process.env.NEXT_PUBLIC_FARO_COLLECTOR_URL;
const apiOrigin = process.env.NEXT_PUBLIC_API_ORIGIN;

// The SDK pre-seeds the exported `faro` object with a noop `api` before registration,
// so `faro.api` is truthy on first load and can't be used as an init guard. The SDK
// publishes itself onto globalThis via setFaroOnGlobalObject with configurable:false,
// so its presence is the canonical "already initialized" signal and survives HMR.
if (collectorUrl && !('faro' in globalThis)) {
  try {
    initializeFaro({
      url: collectorUrl, // Alloy faro.receiver, e.g. http://localhost:12347/collect
      app: {
        name: 'incentives-platform-fe-browser',
        version: process.env.NEXT_PUBLIC_APP_VERSION ?? 'dev',
        environment: process.env.NEXT_PUBLIC_ENV ?? 'local',
      },
      instrumentations: [
        // HARDENED: disable console capture so console.* never ships to Loki.
        ...getWebInstrumentations({ captureConsole: false }),
        new TracingInstrumentation({
          instrumentationOptions: {
            // Attach traceparent ONLY to cross-origin calls to our API origin, never
            // to third-party hosts. Same-origin (browser→Next) is always propagated.
            propagateTraceHeaderCorsUrls: buildApiPropagationMatchers(apiOrigin),
          },
        }),
      ],
      // HARDENED: redact email/SSN/token and strip URL query strings before export.
      beforeSend: scrubTransportItem,
    });
  } catch {
    // Never let telemetry initialization break the app.
  }
}
